/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Billing_Past_ContractInputs */



/**
* | output |
* | --- |
* | "Covered by your contract" |
*
* @param {Dashboard_Billing_Past_ContractInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_past_contract = /** @type {((inputs?: Dashboard_Billing_Past_ContractInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Past_ContractInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Durch Ihren Vertrag abgedeckt")
	return /** @type {LocalizedString} */ ("Covered by your contract")
});